<template>
  <mdb-modal class="text-center" danger size="sm">
    <mdb-modal-header :close="false" center>
      <p class="heading">{{question}}</p>
    </mdb-modal-header>
    <mdb-modal-body>
      <p>{{additionalText}}</p>
      <mdb-icon class="animated" icon="times" size="4x"/>
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn @click="answerYes" color="danger">{{ capitalize($t("common.label.yes")) }}</mdb-btn>
      <mdb-btn @click="answerNo" color="success">{{ capitalize($t("common.label.no")) }}</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>
<script>
import {mdbBtn, mdbIcon, mdbModal, mdbModalBody, mdbModalFooter, mdbModalHeader} from 'mdbvue';

export default {
    name: 'yesNoModal',
    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbModalFooter,
      mdbIcon,
      mdbBtn
    },
    props: {
      question: {
        type: String,
        default: "Are you sure?"
      },
      additionalText: {
        type: String,
        default: null
      }
    },
    methods: {
      answerYes() {
        this.$emit("yes")
      },
      answerNo() {
        this.$emit("no")
      }
    }

  };
</script>
